import React from 'react';
import Reveal from './Reveal';
import { ANT_BUBBLES_URL } from '../data';
import '../styles/frens.css';

const Partners = () => {
  return (
    <section className="section frens" id="partners">
      <Reveal className="frens-head">
        <span className="eyebrow">partners</span>
        <h2 className="section-title">building with the <span className="accent">WAX fam</span></h2>
        <p className="section-lead">
          $KEK partners with projects that add utility and visibility on WAX. External links are provided
          for convenience and carry no endorsement or investment implication.
        </p>
      </Reveal>

      <a className="partner-card glass" href={ANT_BUBBLES_URL}>
        <img src="/antbubbles.svg" alt="" />
        <span>AntBubbles</span>
      </a>
    </section>
  );
};

export default Partners;
